import { useDashData } from 'context/DashDataContext.jsx';
import { Button } from 'components/common';

/**
 * The week is what every tab renders. Until it arrives, those tabs show a
 * spinner — and a failed read used to leave that spinner up, because nothing
 * looked at the error. This is that missing state, in both shells.
 */
export default function WeekGate({ children }) {
  const { data, error, reload, loading } = useDashData();
  if (data || !error) return children;
  return (
    <div className='empty'>
      <p>{error}</p>
      <div className='u-row u-row--end u-mt-sm'>
        <Button size='sm' variant='outline' onClick={reload} disabled={loading}>
          {loading ? 'Loading…' : 'Try again'}
        </Button>
      </div>
    </div>
  );
}
